import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';

const RecommendedTask = ({ taskId, onCountdownEnd }) => {
  const [countdown, setCountdown] = useState(5);
  const [countdownStarted, setCountdownStarted] = useState(false);

  useEffect(() => {
    if (countdownStarted && countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);

      return () => clearTimeout(timer);
    } else if (countdown === 0) {
      onCountdownEnd();
    }
  }, [countdown, countdownStarted, onCountdownEnd]);

  const startCountdown = () => {
    setCountdownStarted(true);
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" component="h3" gutterBottom>
        Recommended Task to Start With: {taskId}
      </Typography>
      {countdownStarted ? (
        <Typography variant="body1" component="p" gutterBottom>
          Begin in {countdown}
        </Typography>
      ) : (
        <Button variant="contained" onClick={startCountdown}>
          Start
        </Button>
      )}
    </Box>
  );
};

export default RecommendedTask;
